import axios from 'axios'

export default {
    namespaced: true,
    state: {
        states: [],
        loadingStates: false,
    },
    mutations: {
        SET_STATES(state, states) {
            state.states = states;
        },
        SET_LOADING_STATES(state, loading) {
            state.loadingStates = loading;
        }
    },
    getters: {
        states: state => state.states,
        loadingStates: state => state.loadingStates,
    },
    actions: {
        loadStates({ commit }) {
            return new Promise(resolve => {
                commit("SET_LOADING_STATES", true);
                axios.get("/state/get-all")
                    .then((res) => {
                        commit("SET_STATES", res.data.states);
                        resolve(res.data.states);
                        commit("SET_LOADING_STATES", false);
                    })
                    .catch((err) => {
                        console.log(err);
                        commit("SET_LOADING_STATES", false);
                    });
                commit("SET_LOADING_STATES", false);
            });

        }
    },
}
